export default "__VITE_ASSET__CPSnjXzS__"